import { gql } from '@apollo/client/core';
import { useMutation } from '@vue/apollo-composable';
import { deleteGroups } from '@spectee/graphql/mutations';

const document = gql(deleteGroups);

export function useDeleteGroups() {
  return useMutation(document);
}
